import { render } from "./ModificaRapportino.vue?vue&type=template&id=0877653a&scoped=true"
import script from "./ModificaRapportino.vue?vue&type=script&lang=js"
export * from "./ModificaRapportino.vue?vue&type=script&lang=js"

import "./ModificaRapportino.vue?vue&type=style&index=0&id=0877653a&scoped=true&lang=css"

import exportComponent from "/Users/andrea/Sites/app_v2/app_entasys/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0877653a"]])

export default __exports__